(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sp-footer"] && !Shopify.designMode) return;
  try {
    
  function initializeSpFooters(){
    document.querySelectorAll('[data-sp-footer]').forEach(function(footer){
      if(footer.dataset.ready)return;
      footer.dataset.ready='true';
      var desktop=window.matchMedia('(min-width:741px)');
      var groups=footer.querySelectorAll('details');
      function sync(){groups.forEach(function(group){group.open=desktop.matches;});}
      groups.forEach(function(group){group.querySelector('summary').addEventListener('click',function(event){if(desktop.matches)event.preventDefault();});});
      desktop.addEventListener('change',sync);
      sync();
    });
  }
  initializeSpFooters();
  document.addEventListener('shopify:section:load',initializeSpFooters);

  } catch(e) { console.error(e); }
})();
})();
